import React, { FC, useMemo } from 'react';
import History from 'src/components/History';
import { ConstantsCodesObjectType } from 'src/types/constantsCodes';
import { WebhookChangelogType } from 'src/types/webhookDetail';
import { historyUpdates } from './constants';
import { normalizeWebhookHistoryUpdates } from './functions';

export interface HistoryBlockPropsType {
    changelog: WebhookChangelogType | null;
    webhookTypeCodesObject: ConstantsCodesObjectType;
    boolNumberCodesObject: ConstantsCodesObjectType;
    methodCodesObject: ConstantsCodesObjectType;
}

const HistoryBlock: FC<HistoryBlockPropsType> = (props) => {
    const updates = useMemo(
        () => normalizeWebhookHistoryUpdates(props.changelog?.updates),
        [props.changelog?.updates],
    );

    return (
        <History
            updates={updates}
            defaultExpandAll
            updateKeys={historyUpdates}
            keyCodes={{
                WEBHOOK_TYPE: props.webhookTypeCodesObject,
                ACTIVE: props.boolNumberCodesObject,
                METHOD: props.methodCodesObject,
            }}
            translatePrefix="webhookDetail"
        />
    );
};

export default HistoryBlock;
